export default "__VITE_ASSET__CgAOxPnQ__"